import { render, staticRenderFns } from "./AddOffenderModal.vue?vue&type=template&id=3d4302e4"
import script from "./AddOffenderModal.vue?vue&type=script&lang=js"
export * from "./AddOffenderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports